export { ProperName } from "./ProperName";
